import {DataObjectId} from 'yougile-model'
import {OptionsItemCheckbox} from '@components/common/base/dropdown-button-menu/types'
import {getColumns} from '../destination/get-columns'

export const getColumnsOptions = (
  boardId: DataObjectId,
  selected = true
): OptionsItemCheckbox[] => {
  if (!boardId) {
    return []
  }

  const columns = getColumns(boardId)

  const options: OptionsItemCheckbox[] = columns.map(({id, title}) => ({
    id,
    text: title,
    selected
  }))

  return options
}
